import { render, staticRenderFns } from "./primaryBox.vue?vue&type=template&id=38f4c469"
import script from "./primaryBox.vue?vue&type=script&lang=js"
export * from "./primaryBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports